module.exports = __webpack_public_path__ + "img/ic_ofuro.1554a722.svg";